import type { CustomerLanguage } from "@/lib/customer-language";

const MATCHING_COPY = {
  en: {
    personA: "Person A",
    personB: "Person B",
    nextPersonB: "Next: Enter Person B",
    calculate: "Calculate Gun Milan",
    change: "Change",
    loading: "Calculating Ashtakoot Gun Milan...",
    loadingDetail: "Generating kundalis and matching all 8 kootas",
    genericError: "Something went wrong",
    detailedError: "Failed to generate detailed report",
    compatibility: "compatibility",
    moon: "Moon",
    nakshatra: "Nakshatra",
    lagna: "Lagna",
    kootaBreakdown: "Ashtakoot (8 Koota) Breakdown",
    mangalStatus: "Mangal Dosha Status",
    mangalMeaning: "What does Mangal Dosha mean for this match?",
    recommendation: "Recommendation",
    deeperTitle: "Want Deeper Insights?",
    deeperBody:
      "Get Navamsha (D9) chart analysis, Dasha compatibility for the next 5 years, Dosha cross-check, and personalised upay recommendations.",
    deeperLoading: "Analysing charts...",
    deeperCta: "Get Detailed Report",
    navamshaAnalysis: "Navamsha Analysis",
    dashaCompatibility: "Dasha Compatibility",
    doshaCrosscheck: "Dosha Cross-Check",
    upayRecommendations: "Upay Recommendations",
    comprehensiveCompatibility: "Comprehensive Compatibility",
    challengingPeriods: "Challenging Periods Ahead",
    recommendedUpay: "Recommended Upay",
    recommendedPujaItems: "Recommended Puja Items",
    pujaItemsBody:
      "Based on the dosha analysis, these sacred products can help harmonise the planetary energies for this couple.",
    view: "View",
    generatingPdf: "Generating PDF...",
    downloadPdf: "Download PDF Report",
    fullReport: "Get Full Kundali Reading →",
    matchAnother: "Match Another Pair",
    modeBirth: "By birth details",
    modeNaam: "By naam (no birth time)",
    naamIntro:
      "Enter each person's name, or their naam-akshar if you know it. We will confirm which nakshatra it points to before showing any score.",
    naamNameLabel: "Full name",
    naamAksharLabel: "Naam-akshar",
    naamIsNameOption: "This is a name",
    naamIsAksharOption: "This is the akshar",
    naamCheck: "Check naam-akshar",
    naamChecking: "Checking the naam-akshar table...",
    naamCalculate: "Calculate Gun Milan",
    naamChooseHeading: "Which nakshatra is this akshar?",
    naamChooseBody:
      "This akshar belongs to more than one nakshatra, and they do not give the same score. Pick the one from the naamkaran.",
    naamNotFoundHeading: "This akshar is not in the naam-akshar table",
    naamNotFoundBody:
      "Joined syllables like Vrinda or Pragya have no cell of their own. Pick the naamkaran akshar from the list instead.",
    naamPickerOpen: "Pick from the akshar list",
    naamPickerClose: "Close the list",
    naamConfirmed: "Confirmed",
    naamChange: "Change",
    naamPada: "pada",
    naamBoundaryHeading: "What this score can and can't tell you",
    naamBoundaryPremise:
      "This is the Gun Milan your two naam-akshar point to — it is not a birth-time match.",
    naamBoundaryJanma:
      "Naam milan traditionally uses the janma naam: the syllable given at naamkaran, chosen from the birth nakshatra. Most people's everyday name was never chosen that way — so if these akshar didn't come from the naamkaran, the nakshatra behind this score isn't yours either.",
    naamBoundaryMangal:
      "Mangal Dosh is not checked here. That needs Mars's house placement, which only a full kundali gives.",
    naamSwitchToBirth: "Match with exact birth time",
    naamGenericError: "Something went wrong",
  },
  hi: {
    personA: "Pehli kundali",
    personB: "Doosri kundali",
    nextPersonB: "Agla: doosri kundali bharein",
    calculate: "Gun Milan calculate karein",
    change: "Badlein",
    loading: "Ashtakoot Gun Milan calculate ho raha hai...",
    loadingDetail: "Dono kundali aur sabhi 8 koota match ho rahe hain",
    genericError: "Kuch theek nahi chala. Dobara koshish karein.",
    detailedError: "Detailed report nahi ban paayi. Dobara koshish karein.",
    compatibility: "match",
    moon: "Chandra",
    nakshatra: "Nakshatra",
    lagna: "Lagna",
    kootaBreakdown: "Ashtakoot ke 8 Koota",
    mangalStatus: "Mangal Dosh status",
    mangalMeaning: "Is match ke liye Mangal Dosh ka kya matlab hai?",
    recommendation: "Jyotish guidance",
    deeperTitle: "Match ko aur gehra samjhein",
    deeperBody:
      "Navamsha (D9), agle 5 saal ki dasha compatibility, dosha cross-check aur personalised upay dekhein.",
    deeperLoading: "Dono kundali analyse ho rahi hain...",
    deeperCta: "Detailed Report dekhein",
    navamshaAnalysis: "Navamsha Analysis",
    dashaCompatibility: "Dasha Compatibility",
    doshaCrosscheck: "Dosha Cross-Check",
    upayRecommendations: "Upay Recommendations",
    comprehensiveCompatibility: "Complete Compatibility",
    challengingPeriods: "Aage ke challenging periods",
    recommendedUpay: "Suggested Upay",
    recommendedPujaItems: "Suggested Puja Items",
    pujaItemsBody:
      "Dosha analysis ke hisaab se ye puja items couple ki graha energy ko balance karne mein madad kar sakte hain.",
    view: "Dekhein",
    generatingPdf: "PDF ban rahi hai...",
    downloadPdf: "PDF Report download karein",
    fullReport: "Poori Kundali Reading dekhein →",
    matchAnother: "Doosra match karein",
    modeBirth: "Janm details se",
    modeNaam: "Naam se (birth time ke bina)",
    naamIntro:
      "Dono ka naam likhein, ya naam-akshar pata ho to wahi. Score dikhane se pehle hum confirm karenge ki woh kis Nakshatra ka hai.",
    naamNameLabel: "Poora naam",
    naamAksharLabel: "Naam-akshar",
    naamIsNameOption: "Yeh naam hai",
    naamIsAksharOption: "Yeh akshar hai",
    naamCheck: "Naam-akshar check karein",
    naamChecking: "Naam-akshar table check ho rahi hai...",
    naamCalculate: "Gun Milan calculate karein",
    naamChooseHeading: "Yeh akshar kis Nakshatra ka hai?",
    naamChooseBody:
      "Yeh akshar ek se zyada Nakshatra ka hai, aur unke score alag aate hain. Naamkaran wala chunein.",
    naamNotFoundHeading: "Yeh akshar naam-akshar table mein nahi hai",
    naamNotFoundBody:
      "Vrinda ya Pragya jaise joined akshar ka alag box nahi hota. List se Naamkaran wala akshar chunein.",
    naamPickerOpen: "Akshar list se chunein",
    naamPickerClose: "List band karein",
    naamConfirmed: "Confirmed",
    naamChange: "Badlein",
    naamPada: "Pada",
    naamBoundaryHeading: "Yeh score kya bata sakta hai, aur kya nahi",
    naamBoundaryPremise:
      "Yeh Gun Milan aap dono ke naam-akshar se nikla hai — yeh birth-time matching nahi hai.",
    naamBoundaryJanma:
      "Traditional naam matching janm naam par hota hai: woh akshar jo Naamkaran mein janm Nakshatra se chuna jaata hai. Aksar daily-use naam is tarah nahi chuna jaata — isliye agar yeh Naamkaran wale akshar nahi hain, to score ke peeche ka Nakshatra bhi aapka nahi hoga.",
    naamBoundaryMangal:
      "Mangal Dosh yahan check nahi hua. Uske liye Mangal ka bhav chahiye, jo poori kundali se milta hai.",
    naamSwitchToBirth: "Exact birth time se match karein",
    naamGenericError: "Kuch theek nahi chala. Dobara koshish karein.",
  },
} as const;

export function matchingCopy(language: CustomerLanguage) {
  return MATCHING_COPY[language];
}
